import {FormLabel, styled} from '@mui/material';

export const StyledFormLabel = styled(FormLabel)`
  align-self: stretch;
`;
